// ./src/utils/colorHelpers.ts
export const getRandomHexColor = (): string => {
  const randomColor = Math.floor(Math.random() * 0xffffff);
  return `#${randomColor.toString(16).padStart(6, "0")}`;
};

export const getMostContrastingColor = (hex: string): string => {
  // Normalize hex (remove # and expand shorthand)
  let cleanHex = hex.replace(/^#/, "");
  if (cleanHex.length === 3) {
    cleanHex = cleanHex
      .split("")
      .map((ch) => ch + ch)
      .join("");
  } else if (cleanHex.length === 4) {
    // #RGBA → #RRGGBBAA
    cleanHex = cleanHex
      .split("")
      .map((ch) => ch + ch)
      .join("");
  }

  // Parse RGB and Alpha
  let r = 0,
    g = 0,
    b = 0,
    a = 255;
  if (cleanHex.length === 6 || cleanHex.length === 8) {
    r = parseInt(cleanHex.substring(0, 2), 16);
    g = parseInt(cleanHex.substring(2, 4), 16);
    b = parseInt(cleanHex.substring(4, 6), 16);
    if (cleanHex.length === 8) {
      a = parseInt(cleanHex.substring(6, 8), 16);
    }
  } else {
    throw new Error("Invalid hex color format.");
  }

  // Compute luminance (per WCAG)
  const srgb = [r, g, b].map((v) => {
    const normalized = v / 255;
    return normalized <= 0.03928
      ? normalized / 12.92
      : Math.pow((normalized + 0.055) / 1.055, 2.4);
  });
  const luminance = 0.2126 * srgb[0] + 0.7152 * srgb[1] + 0.0722 * srgb[2];

  // Compare contrast with black (0) and white (1)
  const contrastBlack = (luminance + 0.05) / 0.05;
  const contrastWhite = 1.05 / (luminance + 0.05);

  // Pick whichever has higher contrast ratio
  const best = contrastBlack > contrastWhite ? "#000000" : "#FFFFFF";

  // Preserve transparency if present
  if (a !== 255) {
    const alphaHex = a.toString(16).padStart(2, "0");
    return best + alphaHex;
  }

  return best;
};
